import { useNotifications } from '@sequencehq/core-components'
import { useMutation } from '@sequencehq/api/utils'
import { dashboardv99990101Client } from '@sequencehq/api/dashboard/v99990101'

export const useCreateAvalaraMapping = () => {
  const { displayNotification } = useNotifications()

  const createMappingMutator = useMutation(
    dashboardv99990101Client.postTaxCategoryAvalaraMapping
  )

  return async ({
    taxCategoryId,
    avalaraTaxCode
  }: {
    taxCategoryId: string
    avalaraTaxCode: string
  }) => {
    await createMappingMutator.mutateAsync(
      {
        taxCategoryId,
        avalaraTaxCode
      },
      {
        onSuccess: () => {
          displayNotification('Avalara tax code linked to category', {
            type: 'success'
          })
        },
        onError: () => {
          displayNotification('Failed to link Avalara tax code to category', {
            type: 'error'
          })
        }
      }
    )
  }
}
